import * as MutationTypes from '@dynameat/mutationTypes';

export const setLoading = ({ commit }, payload) => {
  commit(MutationTypes.SET_LOADING, payload);
};
